// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__bZp8T","title":"BackImages_title__1wUHR","images":"BackImages_images__1pb6m"};